import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=0d70c608&scoped=true&lang=pug&"
import script from "./marquee.vue?vue&type=script&lang=js&"
export * from "./marquee.vue?vue&type=script&lang=js&"
import style0 from "./marquee.vue?vue&type=style&index=0&id=0d70c608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d70c608",
  null
  
)

export default component.exports